export default __webpack_public_path__ + "static/climate_change-74558df90570bff14ea4d7bdc215d6be.jpg";